export { default } from 'shared/components/icon'
